import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetRegisteredSessions, GetRegisteredSessionsResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetRegisteredSessionsResponse, GetRegisteredSessionsResponse>) => response?.data?.registrationSessions;

const getError = (response?: SWRResponse<GetRegisteredSessionsResponse, GetRegisteredSessionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetRegisteredSessionsResponse, GetRegisteredSessionsResponse>) => ({
    registrationSessions: response?.data?.registrationSessions
});

export const useUserRegisteredSessions = (id?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {

        if (!id) {
            return undefined;
        }
        
        return () => {
            return new GetRegisteredSessions({id});
        };
    }, [id])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useUserRegisteredSessions;